__webpack_require__.p = "https://releases.rancher.com/harvester-ui/dashboard/latest/";